import React from "react";
import { MaterialReactTable } from "material-react-table";
import PropTypes from "prop-types";

export function MaterialTable({ columnNames, tableData, tableTitle }) {
    // columnNames from your old code = [{ title: 'Name', field: 'name' }]
    // material-react-table expects [{ accessorKey: 'name', header: 'Name' }]
    const columns = columnNames.map((col) => ({
        accessorKey: col.field,
        header: col.title,
    }));

    return (
        <div style={{ marginRight: 11 }}>
            <MaterialReactTable
                columns={columns}
                data={tableData}
                enableSorting
                enablePagination={false}
                enableGlobalFilter={false} // disables search bar
                muiTableHeadCellProps={{
                    sx: {
                        backgroundColor: "#D8F3FC",
                        color: "#53889B",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                        fontSize: "12px",
                        fontFamily: "Poppins",
                        textAlign: "left",
                    },
                }}
                muiTableBodyRowProps={({ row }) => ({
                    sx: {
                        textAlign: "left",
                        borderLeft:
                            row.original.isNewUser === true
                                ? "4px solid #cf2948"
                                : "none",
                    },
                })}
                renderTopToolbarCustomActions={() => (
                    <span
                        style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                            color: "#53889B",
                            fontFamily: "Poppins",
                        }}
                    >
                        {tableTitle}
                    </span>
                )}
                localization={{
                    noRecordsToDisplay: "No Record Found",
                }}
            />
        </div>
    );
}

MaterialTable.propTypes = {
    columnNames: PropTypes.array.isRequired,
    tableData: PropTypes.array.isRequired,
    tableTitle: PropTypes.string,
};
